<div
  class="layout-wrapper layout-content-navbar"
  style="background-color: #f8f8ff"
>
  <!-- Hamburger Menu Button (visible on small screens) -->
  <button class="menu-btn" [ngClass]="{ 'sidebar-open': isSidebarVisible }" (click)="toggleSideNav()">
               <i class="bx bx-chevron-right"></i>
  </button>

  <div class="layout-container d-flex">
    <div class="container-xxl flex-grow-1 container-p-y">
      <div class="row g-0">
        <!-- Side Nav for Folders -->
        <div class="sidebar-wrapper col-12 col-sm-6 col-md-4" [ngClass]="{ 'show-nav': isSidebarVisible }">
          <div class="sidebar-card">
            <aside
              id="layout-menu"
              class="layout-menu menu-vertical menu bg-menu-theme"
              [ngClass]="{ 'show-nav': isSidebarVisible }"
            >
              <div class="menu-inner-shadow"></div>
              <div class="menu-item">
                <div
                  class="px-6 py-2 border-bottom d-flex justify-content-between align-items-center w-100"
                >
                  <div class="d-flex align-items-center">
                    <h5 class="folder-heading mb-0">
                      {{ template?.name || "ECRF Template" }}
                    </h5>
                  </div>
                </div>
                <!-- Create Folder Input -->
                <div class="p-3 border-bottom">
                  <div class="input-group input-group-sm">
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="newFolderName"
                      placeholder="New folder name"
                      (keyup.enter)="createFolder()"
                      style="border-right: 0;"
                    />
                    <button
                      class="btn btn-primary"
                      (click)="createFolder()"
                      [disabled]="!newFolderName.trim()"
                      style="background-color: #3b1e61 !important; border-top-left-radius: 0; border-bottom-left-radius: 0;"
                    >
                      <i class="bx bx-plus"></i>
                    </button>
                  </div>
                </div>
                <!-- Dynamic Folders List -->
                <ul class="list-group list-group-flush" cdkDropList (cdkDropListDropped)="onFolderDrop($event)">
                  <li
                    class="list-group-item border-0"
                    *ngFor="let folder of template?.folders || []"
                    cdkDrag
                    [cdkDragStartDelay]="250"
                    (cdkDragStarted)="onDragStarted()"
                    (cdkDragEnded)="onDragEnded()"
                  >
                    <!-- Folder Header -->
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div
                        class="d-flex align-items-center w-100 cursor-pointer"
                        (click)="onFolderClick(folder, $event)"
                        [ngClass]="{
                          'highlighted-folder': selectedFolderId === folder.id,
                        }"
                      >
                        <i class="menu-icon tf-icons bx bx-layout"></i>
                        <span class="text-truncate">{{ folder.name }}</span>
                      </div>
                      <div class="d-flex align-items-center">
                        <!-- Close folder button (only show when folder is open) -->
                        <!-- <button 
                          *ngIf="selectedFolderId === folder.id" 
                          class="btn btn-sm btn-outline-secondary me-2" 
                          (click)="closeFolder()"
                          title="Close folder"
                          style="padding: 2px 6px; font-size: 12px;"
                        >
                          <i class="bx bx-x"></i>
                        </button> -->
                        <!-- Folder Three Dots Menu -->
                        <div class="dropdown">
                          <button
                            class="dropdown-btn dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            (click)="onDropdownButtonClick($event)"
                          >
                            <i class="bx bx-dots-vertical"></i>
                          </button>
                          <ul class="dropdown-menu">
                            <li>
                              <a
                                class="dropdown-item"
                                (click)="openCreateFormModal(folder)"
                                >Create Form</a
                              >
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                (click)="editFolder(folder)"
                                >Edit Folder</a
                              >
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                (click)="duplicateFolder(folder)"
                                >Duplicate Folder</a
                              >
                            </li>
                            <li>
                              <a
                                class="dropdown-item"
                                (click)="deleteFolder(folder)"
                                >Delete Folder</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <!-- Forms in Folder (visible when folder selected or when dragging to allow drop on other folders) -->
                    <ul
                      class="list-group list-group-flush ps-4"
                      *ngIf="selectedFolderId === folder.id || isDragging"
                      [id]="'form-list-' + folder.id"
                      cdkDropList
                      [cdkDropListData]="getFolderForms(folder)"
                      [cdkDropListConnectedTo]="getFormDropListIds()"
                      (cdkDropListDropped)="onFormDrop($event, folder)"
                    >
                      <li
                        class="list-group-item border-0 p-1"
                        *ngFor="let form of folder.forms || []"
                        cdkDrag
                        [cdkDragStartDelay]="250"
                        (cdkDragStarted)="onDragStarted()"
                        (cdkDragEnded)="onDragEnded()"
                        (click)="onFormClick(form, $event)"
                        [ngClass]="{
                          'highlighted-form': selectedForm === form.name,
                        }"
                        style="font-size: 13px; cursor: pointer"
                      >
                        <div>
                          {{ form.name }}
                        </div>
                        <div>
                          <!-- Form Three Dots Menu -->
                          <div class="dropdown">
                            <button
                              class="dropdown-btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              (click)="onDropdownButtonClick($event); $event.stopPropagation()"
                              [id]="'form-dropdown-' + form.id"
                            >
                              <i class="bx bx-dots-vertical"></i>
                            </button>
                            <ul
                              class="dropdown-menu"
                              [id]="'form-menu-' + form.id"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  (click)="editForm(form)"
                                  [class.disabled]="formCreationLoading"
                                  [style.pointer-events]="
                                    formCreationLoading ? 'none' : 'auto'
                                  "
                                  [style.opacity]="
                                    formCreationLoading ? '0.5' : '1'
                                  "
                                  >Edit Form</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  (click)="duplicateForm(form)"
                                  [class.disabled]="formCreationLoading"
                                  [style.pointer-events]="
                                    formCreationLoading ? 'none' : 'auto'
                                  "
                                  [style.opacity]="
                                    formCreationLoading ? '0.5' : '1'
                                  "
                                  >Duplicate Form</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  (click)="openMoveFormModal(form)"
                                  [class.disabled]="formCreationLoading"
                                  [style.pointer-events]="
                                    formCreationLoading ? 'none' : 'auto'
                                  "
                                  [style.opacity]="
                                    formCreationLoading ? '0.5' : '1'
                                  "
                                  >Move to folder...</a
                                >
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  (click)="deleteForm(form)"
                                  [class.disabled]="formCreationLoading"
                                  [style.pointer-events]="
                                    formCreationLoading ? 'none' : 'auto'
                                  "
                                  [style.opacity]="
                                    formCreationLoading ? '0.5' : '1'
                                  "
                                  >Delete Form</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              <!-- Empty state -->
              <div
                class="text-center py-4"
                *ngIf="
                  (!template?.folders && !loading) ||
                  (template?.folders.length === 0 && !loading)
                "
              >
                <i class="bx bx-folder-open display-6 text-muted"></i>
                <div class="text-muted small">No folders yet</div>
              </div>
            </aside>
          </div>
        </div>
        <!-- Main Content Area -->
        <div class="main-content col-12 col-sm-6 col-md-8">
          <!-- Back Button - Always Visible in Main Content -->
          <div class="mb-1">
            <button
              class="btn custom-button"
              (click)="navigateToBuildTemplates()"
            >
              Back
            </button>
          </div>
          <div class="card" *ngIf="currentForm">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <div class="d-flex align-items-center">
                <h5 class="card-title mb-0">{{ currentForm.name.toUpperCase() }}</h5>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button
                  class="btn custom-button btn-sm"
                  (click)="openCreateFieldModal()"
                >
                  <i class="bx bx-plus me-1"></i>Create Field
                </button>
              </div>
            </div>
            <!-- Form Title and Description -->
            <div
              *ngIf="currentForm.title || currentForm.description"
              class="form-header-section"
            >
              <div *ngIf="currentForm.title" class="form-title">
                <h4 class="section-title">{{ currentForm.title }}</h4>
              </div>
              <div *ngIf="currentForm.description" class="form-description">
                <p class="section-description">{{ currentForm.description }}</p>
              </div>
            </div>
            <div class="card-body">
              <!-- Dynamic Form Fields -->
              <form [formGroup]="form" class="dynamic-form" *ngIf="form">
                <div class="form-fields-grid" cdkDropList (cdkDropListDropped)="onFieldDrop($event)">
                  <ng-container *ngFor="let field of fields; let i = index">
                    <!-- Title field - completely separate from form structure -->
                    <div
                      *ngIf="field.type === 'title' && shouldShowField(field)"
                      class="title-field position-relative"
                      cdkDrag
                      [cdkDragStartDelay]="250"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <div class="flex-grow-1">
                          <h5 class="section-title">{{ field.title }}</h5>
                          <p *ngIf="field.description" class="section-description">
                            {{ field.description }}
                          </p>
                        </div>
                        <!-- Field actions - Three dots menu for title field -->
                        <div
                          class="menu-icon"
                          (click)="openOptionsModal($event, $event.target, i)"
                        >
                          ⋮
                        </div>
                      </div>
                      <!-- Small Modal (Right-side) - Options for title field -->
                      <div
                        class="options-modal"
                        *ngIf="isOptionsModalOpen && clickedFieldIndex === i"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="modal-buttons">
                          <button (click)="editField(i)">Edit Field</button>
                          <button (click)="deleteFieldConfirm(i)">
                            Delete Field
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Regular form fields wrapper -->
                    <div
                      class="form-group-wrapper position-relative mb-2"
                      [ngClass]="{'instruction-field-wrapper': field.type === 'instruction'}"
                      *ngIf="shouldShowField(field) && field.type !== 'title'"
                      cdkDrag
                      [cdkDragStartDelay]="250"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <label class="form-label" style="font-size: 20px; font-weight: bold;">
                          <span>{{ formatFieldTitle(field.title) }}</span>
                          <span *ngIf="field.required" class="text-danger ms-1">*</span>
                          <i
                            *ngIf="field.hasDependency"
                            class="bx bx-link-external ms-2 text-info"
                            title="This field has a dependency"
                            style="font-size: 14px"
                          ></i>
                        </label>
                        <!-- Field actions - Three dots menu -->
                        <div
                          class="menu-icon"
                          (click)="openOptionsModal($event, $event.target, i)"
                        >
                          ⋮
                        </div>
                      </div>
                      <!-- Small Modal (Right-side) - Options -->
                      <div
                        class="options-modal"
                        *ngIf="isOptionsModalOpen && clickedFieldIndex === i"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="modal-buttons">
                          <!-- <button (click)="openModal()">Query</button> -->
                          <button (click)="editField(i)">Edit Field</button>
                          <button (click)="duplicateField(i)">
                            Duplicate Field
                          </button>
                          <button (click)="deleteFieldConfirm(i)">
                            Delete Field
                          </button>
                          <!-- <button (click)="editStudy()">Edit</button> -->
                          <!-- <button type="button" (click)="openReviewModal($event)">
                            Review
                          </button> -->
                        </div>
                      </div>
                      <!-- Edit Reason Modal -->

                      <div class="modal-overlay" *ngIf="isReasonModalOpen">
                        <div class="modal-content">
                          <button
                            class="close-btn"
                            (click)="cancelEditReason()"
                          >
                            ×
                          </button>
                          <h4>Please provide a reason for editing:</h4>
                          <textarea
                            class="form-control"
                            [(ngModel)]="editReason"
                            rows="4"
                            placeholder="Enter reason here..."
                          ></textarea>
                          <div class="modal-footer">
                            <button
                              class="btn custom-button"
                              (click)="confirmEditReason()"
                            >
                              Confirm
                            </button>
                            <button
                              class="btn custom-button"
                              (click)="cancelEditReason()"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                      <!-- Query and Field History Modal -->
                      <div class="modal-overlay" *ngIf="isModalOpen">
                        <div class="modal-content">
                          <button class="close-btn" (click)="closeModal()">
                            &times;
                          </button>
                          <!-- Tab Bar -->
                          <div class="tab-bar">
                            <div
                              class="tab"
                              *ngFor="let tab of tabs; let idx = index"
                              [class.active]="selectedTab === idx"
                              (click)="selectTab(idx)"
                            >
                              {{ tab.title }}
                            </div>
                            <div
                              *ngIf="tabs[selectedTab].type === 'query'"
                              class="add-btn-wrapper"
                            >
                              <button class="add-btn" (click)="addQuery(i)">
                                +
                              </button>
                              <span class="add-query-tooltip">Add Query</span>
                            </div>
                          </div>
                          <!-- Modal Body -->
                          <div class="modal-body">
                            <ng-container [ngSwitch]="tabs[selectedTab].type">
                              <!-- Query Tab -->
                              <div *ngSwitchCase="'query'">
                                <div
                                  *ngFor="let query of queries; let i = index"
                                  class="query-box"
                                >
                                  <div class="input-checkbox-container">
                                    <input
                                      type="text"
                                      class="form-control"
                                      [value]="''"
                                      (input)="query.text = $event.target.value"
                                      [readonly]="query.isClosed"
                                      [ngClass]="{
                                        'query-closed': query.isClosed,
                                      }"
                                      placeholder="Enter your query"
                                    />
                                  </div>
                                  <!-- Audit Trail -->
                                  <div class="audit-trail">
                                    <h4>Audit Trail</h4>
                                    <div
                                      class="audit-entry"
                                      *ngFor="let entry of query.auditTrail"
                                    >
                                      <strong>{{ entry.user || 'System' }}</strong
                                      >-
                                      {{
                                        entry.timestamp
                                          | date: "dd-MMM-yyyy h:mm a"
                                      }}
                                      <p>{{ entry.message }}</p>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button
                                      class="btn custom-button"
                                      [ngClass]="{
                                        'btn-disabled': query.isClosed,
                                      }"
                                      (click)="
                                        !query.isClosed && confirmCloseQuery(i)
                                      "
                                    >
                                      Close Query
                                    </button>
                                    <button
                                      class="btn custom-button ms-2"
                                      (click)="confirmSubmitQuery(i)"
                                      [disabled]="query.isClosed"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- Field History Tab -->
                              <div *ngSwitchCase="'fieldHistory'">
                                <div
                                  *ngIf="
                                    fieldHistoryData?.length > 0;
                                    else noData
                                  "
                                >
                                  <div
                                    *ngFor="let entry of fieldHistoryData"
                                    class="history-box"
                                  >
                                    <div class="history-header">
                                      <strong>{{ entry.updated_by }}</strong> -
                                      {{ entry.updated_at | date: "medium" }}
                                    </div>
                                    <div class="history-value">
                                      {{ entry.value }}
                                    </div>
                                    <!-- Show edit reason if available -->
                                    <div
                                      class="edit-reason"
                                      *ngIf="entry.edit_reason"
                                    >
                                      <em
                                        >Reason for change:
                                        {{ entry.edit_reason }}</em
                                      >
                                    </div>
                                  </div>
                                </div>
                                <ng-template #noData>
                                  <p>No history available for this field.</p>
                                </ng-template>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <!-- Conditional Navigation Buttons -->
                      <div
                        class="mt-3"
                        *ngIf="
                          field.type === 'radio' || field.type === 'dropdown'
                        "
                      >
                        <!-- Adverse Events Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'adverse-events')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            (click)="navigateToAdverseEvents()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Adverse Events
                            Data
                          </button>
                        </div>
                        <!-- Laboratory Investigation Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'laboratory')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToLaboratory()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Laboratory Data
                          </button>
                        </div>
                        <!-- Physical Examination Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'physical')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToPhysicalSystemic()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Physical
                            Examination Data
                          </button>
                        </div>
                        <!-- IDRS Assessment Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'idrs')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary btn-sm"
                            (click)="navigateToIDRS()"
                          >
                            <i class="bx bx-plus me-1"></i>Add IDRS Assessment
                            Data
                          </button>
                        </div>
                        <!-- Prior Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-dark btn-sm"
                            (click)="navigateToPriorMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Prior Medication
                            Data
                          </button>
                        </div>
                        <!-- Concomitant Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            (click)="navigateToConcomitantMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Concomitant
                            Medication Data
                          </button>
                        </div>
                        <!-- Rescue Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-warning btn-sm"
                            (click)="navigateToRescueMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Rescue Medication
                            Data
                          </button>
                        </div>
                        <!-- Medical History Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('medical history') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-info btn-sm"
                            (click)="navigateToMedicalHistory()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Medical History
                            Data
                          </button>
                        </div>
                        <!-- Baseline Physical Exam Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('physical') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToBaselinePhysicalExam()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Baseline Physical
                            Exam Data
                          </button>
                        </div>
                        <!-- Baseline Lab Investigation Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('laboratory') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToBaselineLabInvestigation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Baseline
                            Laboratory Data
                          </button>
                        </div>
                        <!-- Follow-up Physical Exam Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('physical') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToFollowUpPhysical()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Follow-up
                            Physical Exam Data
                          </button>
                        </div>
                        <!-- Follow-up Lab Investigation Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('laboratory') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToFollowUpLabInvestigation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Follow-up
                            Laboratory Data
                          </button>
                        </div>
                        <!-- Medicine Dispensing Vital Signs Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('medicine') &&
                            field.title.toLowerCase().includes('vital signs') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-success btn-sm"
                            (click)="navigateToMedicineVitalSigns()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Medicine
                            Dispensing Vital Signs Data
                          </button>
                        </div>
                        <!-- Adverse Events Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('adverse event') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            (click)="navigateToAdverseEvents()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Adverse Events
                            Data
                          </button>
                        </div>
                        <!-- Concomitant Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToConcomitantMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Concomitant
                            Medication Data
                          </button>
                        </div>
                        <!-- Rescue Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-warning btn-sm"
                            (click)="navigateToRescueMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Rescue Medication
                            Data
                          </button>
                        </div>
                        <!-- Prior Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-info btn-sm"
                            (click)="navigateToPriorMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Prior Medication
                            Data
                          </button>
                        </div>
                        <!-- Protocol Deviation Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('protocol deviation') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-danger btn-sm"
                            (click)="navigateToProtocolDeviation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Protocol
                            Deviation Data
                          </button>
                        </div>
                        <!-- Study Completion Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('study completion') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-success btn-sm"
                            (click)="navigateToStudyCompletion()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Study Completion
                            Data
                          </button>
                        </div>
                      </div>
                      <!-- Conditional Comment Fields for "No" answers -->
                      <div
                        class="mt-3"
                        *ngIf="
                          field.type === 'radio' &&
                          getFieldValue(field.name) === 'no'
                        "
                      >
                        <!-- Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[field.name + '_vitalSignsComments']
                            "
                            name="vitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Physical Examination Comments -->
                        <div
                          *ngIf="field.title.toLowerCase().includes('physical')"
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_physicalExamComments'
                              ]
                            "
                            name="physicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing physical examination..."
                          >
                          </textarea>
                        </div>
                        <!-- IDRS Assessment Comments -->
                        <div
                          *ngIf="field.title.toLowerCase().includes('idrs')"
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_idrsAssessmentComments'
                              ]
                            "
                            name="idrsAssessmentComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing IDRS assessment..."
                          >
                          </textarea>
                        </div>
                        <!-- Laboratory Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_labInvestigationComments'
                              ]
                            "
                            name="labInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing laboratory investigation..."
                          >
                          </textarea>
                        </div>
                        <!-- Baseline Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselineVitalSignsComments'
                              ]
                            "
                            name="baselineVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Baseline Physical Exam Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('physical')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselinePhysicalExamComments'
                              ]
                            "
                            name="baselinePhysicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline physical examination..."
                          >
                          </textarea>
                        </div>
                        <!-- Baseline Lab Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselineLabInvestigationComments'
                              ]
                            "
                            name="baselineLabInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline laboratory investigation..."
                          >
                          </textarea>
                        </div>
                        <!-- Follow-up Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpVitalSignsComments'
                              ]
                            "
                            name="followUpVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Follow-up Physical Exam Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('physical')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpPhysicalExamComments'
                              ]
                            "
                            name="followUpPhysicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up physical examination..."
                          >
                          </textarea>
                        </div>
                        <!-- Follow-up Lab Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpLabInvestigationComments'
                              ]
                            "
                            name="followUpLabInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up laboratory investigation..."
                          >
                          </textarea>
                        </div>
                        <!-- Medicine Dispensing Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('medicine') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_medicineVitalSignsComments'
                              ]
                            "
                            name="medicineVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing medicine dispensing vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Adverse Events Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('adverse event')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_adverseEventsComments'
                              ]
                            "
                            name="adverseEventsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording adverse events..."
                          >
                          </textarea>
                        </div>
                        <!-- Concomitant Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_concomitantMedicationComments'
                              ]
                            "
                            name="concomitantMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording concomitant medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Rescue Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_rescueMedicationComments'
                              ]
                            "
                            name="rescueMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording rescue medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Prior Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_priorMedicationComments'
                              ]
                            "
                            name="priorMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording prior medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Protocol Deviation Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('protocol deviation')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_protocolDeviationComments'
                              ]
                            "
                            name="protocolDeviationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording protocol deviation..."
                          >
                          </textarea>
                        </div>
                        <!-- Study Completion Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('study completion')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_studyCompletionComments'
                              ]
                            "
                            name="studyCompletionComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not completing study..."
                          >
                          </textarea>
                        </div>
                      </div>
                      <!-- Attachment section shown when enabled for the field -->
                      <div
                        *ngIf="field.attachmentRequired == 1 ? true : false"
                        class="attachment-section mt-3"
                      >
                        <label class="form-label">
                          <i class="fa fa-paperclip"></i> Attachments
                          <span *ngIf="field.required" class="text-danger"
                            >*</span
                          >
                        </label>
                        <div class="file-input-wrapper">
                          <input
                            type="file"
                            class="form-control"
                            [id]="field.name + '_file'"
                            multiple
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif"
                            (change)="onFileSelected($event, field.name)"
                            [formControlName]="field.name + '_attachments'"
                          />
                          <small class="form-text text-muted">
                            Supported: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG, GIF
                          </small>
                        </div>
                        <div
                          *ngIf="selectedFiles[field.name]?.length"
                          class="selected-files mt-2"
                        >
                          <div
                            *ngFor="
                              let file of selectedFiles[field.name];
                              let fileIndex = index
                            "
                            class="selected-file-item d-flex align-items-center justify-content-between p-2 border rounded mb-2"
                          >
                            <div class="d-flex align-items-center">
                              <i
                                [class]="getFileIcon(file.name)"
                                class="me-2"
                              ></i>
                              <span class="file-name">{{ file.name }}</span>
                              <small class="text-muted ms-2"
                                >({{
                                  (file.size / 1024 / 1024).toFixed(2)
                                }}
                                MB)</small
                              >
                            </div>
                            <div class="d-flex align-items-center gap-2">
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                (click)="openFile(file)"
                                title="Open file"
                              >
                                <i class="fa fa-eye"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-success"
                                (click)="downloadFile(file)"
                                title="Download file"
                              >
                                <i class="fa fa-download"></i>
                              </button>
                              <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                (click)="removeFile(field.name, fileIndex)"
                                title="Remove file"
                              >
                                <i class="fa fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Query and Field History Modal -->
                      <div class="modal-overlay" *ngIf="isModalOpen">
                        <div class="modal-content">
                          <button class="close-btn" (click)="closeModal()">
                            &times;
                          </button>
                          <!-- Tab Bar -->
                          <div class="tab-bar">
                            <div
                              class="tab"
                              *ngFor="let tab of tabs; let idx = index"
                              [class.active]="selectedTab === idx"
                              (click)="selectTab(idx)"
                            >
                              {{ tab.title }}
                            </div>
                            <div
                              *ngIf="tabs[selectedTab].type === 'query'"
                              class="add-btn-wrapper"
                            >
                              <button class="add-btn" (click)="addQuery(i)">
                                +
                              </button>
                              <span class="add-query-tooltip">Add Query</span>
                            </div>
                          </div>
                          <!-- Modal Body -->
                          <div class="modal-body">
                            <ng-container [ngSwitch]="tabs[selectedTab].type">
                              <!-- Query Tab -->
                              <div *ngSwitchCase="'query'">
                                <div
                                  *ngFor="let query of queries; let i = index"
                                  class="query-box"
                                >
                                  <div class="input-checkbox-container">
                                    <input
                                      type="text"
                                      class="form-control"
                                      [value]="''"
                                      (input)="query.text = $event.target.value"
                                      [readonly]="query.isClosed"
                                      [ngClass]="{
                                        'query-closed': query.isClosed,
                                      }"
                                      placeholder="Enter your query"
                                    />
                                  </div>
                                  <!-- Audit Trail -->
                                  <div class="audit-trail">
                                    <h4>Audit Trail</h4>
                                    <div
                                      class="audit-entry"
                                      *ngFor="let entry of query.auditTrail"
                                    >
                                      <strong>{{ entry.user || 'System' }}</strong
                                      >-
                                      {{
                                        entry.timestamp
                                          | date: "dd-MMM-yyyy h:mm a"
                                      }}
                                      <p>{{ entry.message }}</p>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button
                                      class="btn custom-button"
                                      [ngClass]="{
                                        'btn-disabled': query.isClosed,
                                      }"
                                      (click)="
                                        !query.isClosed && confirmCloseQuery(i)
                                      "
                                    >
                                      Close Query
                                    </button>
                                    <button
                                      class="btn custom-button ms-2"
                                      (click)="confirmSubmitQuery(i)"
                                      [disabled]="query.isClosed"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <!-- Field History Tab -->
                              <div *ngSwitchCase="'fieldHistory'">
                                <div
                                  *ngIf="
                                    fieldHistoryData?.length > 0;
                                    else noData
                                  "
                                >
                                  <div
                                    *ngFor="let entry of fieldHistoryData"
                                    class="history-box"
                                  >
                                    <div class="history-header">
                                      <strong>{{ entry.updated_by }}</strong> -
                                      {{ entry.updated_at | date: "medium" }}
                                    </div>
                                    <div class="history-value">
                                      {{ entry.value }}
                                    </div>
                                    <!-- Show edit reason if available -->
                                    <div
                                      class="edit-reason"
                                      *ngIf="entry.edit_reason"
                                    >
                                      <em
                                        >Reason for change:
                                        {{ entry.edit_reason }}</em
                                      >
                                    </div>
                                  </div>
                                </div>
                                <ng-template #noData>
                                  <p>No history available for this field.</p>
                                </ng-template>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <!-- Field Inputs -->
                      <input
                        *ngIf="field.type === 'text'"
                        type="text"
                        class="form-control"
                        [formControlName]="getFieldName(field)"
                      />
                      <input
                        *ngIf="field.type === 'date'"
                        type="date"
                        class="form-control"
                        [formControlName]="getFieldName(field)"
                        [max]="maxDate"
                      />
                      <input
                        *ngIf="field.type === 'time'"
                        type="time"
                        class="form-control"
                        [formControlName]="getFieldName(field)"
                      />
                      <input
                        *ngIf="field.type === 'number'"
                        type="number"
                        class="form-control"
                        [formControlName]="getFieldName(field)"
                        [placeholder]="
                          field.unit
                            ? 'Enter value in ' + field.unit
                            : 'Enter number'
                        "
                        min="0"
                      />
                      <!-- Auto-populated converted value (read-only) when configured -->
                      <div
                        *ngIf="field.conversionRequired"
                        class="calculated-field mt-2"
                      >
                        <label class="form-label mb-1">
                          Converted value
                          <span
                            *ngIf="field.conversionFromUnit && field.conversionToUnit"
                          >
                            ({{ field.conversionFromUnit }} →
                            {{ field.conversionToUnit }})
                          </span>
                        </label>
                        <input
                          type="number"
                          class="form-control"
                          [formControlName]="field.name + '_converted'"
                          disabled
                          readonly
                          [placeholder]="'Converted value will populate here'"
                        />
                        <small class="form-text text-muted"
                          >This value is automatically converted</small
                        >
                      </div>
                      <textarea
                        *ngIf="field.type === 'textarea'"
                        class="form-control"
                        [formControlName]="getFieldName(field)"
                      ></textarea>
                      <select
                        *ngIf="
                          field.type === 'select' || field.type === 'dropdown'
                        "
                        class="form-control"
                        [formControlName]="getFieldName(field)"
                      >
                        <option value="">Select</option>
                        <option *ngFor="let opt of field.options" [value]="opt">
                          {{
                            field.valueToLabelMap
                              ? field.valueToLabelMap[opt]
                              : opt
                          }}
                        </option>
                      </select>
                      <div
                        *ngIf="field.type === 'radio'"
                        class="form-check-group"
                      >
                        <div
                          class="form-check"
                          *ngFor="let opt of field.options; let i = index"
                        >
                          <input
                            type="radio"
                            class="form-check-input"
                            [value]="opt"
                            [formControlName]="field.name"
                            [id]="field.name + '_' + opt"
                          />
                          <label
                            class="form-check-label"
                            [for]="field.name + '_' + opt"
                          >
                            {{
                              field.valueToLabelMap
                                ? field.valueToLabelMap[opt]
                                : opt
                            }}
                          </label>
                        </div>
                      </div>
                      <div
                        *ngIf="field.type === 'checkbox'"
                        class="form-check-groupc"
                      >
                        <div
                          class="form-check"
                          *ngFor="let opt of field.options"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            [id]="field.name + '_' + opt"
                            [checked]="
                              (form.get(field.name)?.value || []).includes(opt)
                            "
                            (change)="
                              toggleCheckbox(
                                field.name,
                                opt,
                                $event.target.checked
                              )
                            "
                          />
                          <label
                            class="form-check-label"
                            [for]="field.name + '_' + opt"
                            >{{ opt }}</label
                          >
                        </div>
                      </div>
                      <!-- E-signature field type - just a text input for name -->
                      <input
                        *ngIf="
                          field.type === 'esignature' ||
                          field.type === 'signature'
                        "
                        type="text"
                        class="form-control"
                        [formControlName]="field.name"
                        placeholder="Enter signature name"
                      />
                      <!-- Instruction field type - display only -->
                      <div
                        *ngIf="field.type === 'instruction' && logInstructionField(field)"
                        class="instruction-field-display"
                      >
                        <div *ngIf="field.instructionText">
                          <p style="white-space: pre-wrap; margin: 0; font-size: 14px; line-height: 1.6;">
                            {{ field.instructionText }}
                          </p>
                        </div>
                        <!-- Display instruction images -->
                        <div *ngIf="checkInstructionImages(field)" class="mt-3">
                          <div class="row">
                            <div
                              *ngFor="let image of field.instructionImages; let imgIndex = index"
                              class="col-md-4 col-sm-6 mb-3"
                            >
                              <div class="instruction-image-wrapper">
                                <img
                                  [src]="getInstructionImageSrc(image)"
                                  [alt]="getInstructionImageAlt(image)"
                                  class="img-fluid rounded border"
                                  style="max-height: 200px; width: 100%; object-fit: contain; cursor: pointer;"
                                  (click)="openImageModal(getInstructionImageSrc(image))"
                                  onerror="this.src='data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'200\' height=\'200\'%3E%3Crect fill=\'%23ddd\' width=\'200\' height=\'200\'/%3E%3Ctext fill=\'%23999\' font-family=\'sans-serif\' font-size=\'14\' dy=\'10.5\' font-weight=\'bold\' x=\'50%25\' y=\'50%25\' text-anchor=\'middle\'%3EImage not available%3C/text%3E%3C/svg%3E'"
                                />
                                <small *ngIf="hasImageName(image)" class="d-block mt-1 text-muted text-center">
                                  {{ getInstructionImageName(image) }}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Display instruction table -->
                        <div *ngIf="field.instructionColumns && field.instructionColumns.length > 0" class="mt-3">
                          <div class="table-wrapper">
                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th>Sr. No</th>
                                  <th
                                    *ngFor="
                                      let column of field.instructionColumns;
                                      let colIndex = index
                                    "
                                  >
                                    {{ column.title }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let row of getInstructionTableData(field); let rowIndex = index">
                                  <td class="text-center fw-bold">{{ rowIndex + 1 }}</td>
                                  <td
                                    *ngFor="
                                      let column of field.instructionColumns;
                                      let colIndex = index
                                    "
                                  >
                                    <!-- Display based on column type; preserve 0 values -->
                                    <span *ngIf="column.type === 'text'">
                                      {{
                                        row[column.title] !== null &&
                                        row[column.title] !== undefined &&
                                        row[column.title] !== ''
                                          ? row[column.title]
                                          : '-'
                                      }}
                                    </span>
                                    <span *ngIf="column.type === 'number'">
                                      {{
                                        row[column.title] !== null &&
                                        row[column.title] !== undefined &&
                                        row[column.title] !== ''
                                          ? row[column.title]
                                          : '-'
                                      }}
                                    </span>
                                    <span *ngIf="column.type === 'date'">
                                      {{
                                        row[column.title] !== null &&
                                        row[column.title] !== undefined &&
                                        row[column.title] !== ''
                                          ? row[column.title]
                                          : '-'
                                      }}
                                    </span>
                                    <span *ngIf="column.type === 'textarea'">
                                      {{
                                        row[column.title] !== null &&
                                        row[column.title] !== undefined &&
                                        row[column.title] !== ''
                                          ? row[column.title]
                                          : '-'
                                      }}
                                    </span>
                                    <span *ngIf="column.type === 'checkbox'">
                                      {{ row[column.title] ? 'Yes' : 'No' }}
                                    </span>
                                    <span *ngIf="column.type === 'dropdown'">
                                      {{
                                        row[column.title] !== null &&
                                        row[column.title] !== undefined &&
                                        row[column.title] !== ''
                                          ? row[column.title]
                                          : '-'
                                      }}
                                    </span>
                                  </td>
                                </tr>
                                <tr *ngIf="!getInstructionTableData(field) || getInstructionTableData(field).length === 0">
                                  <td [attr.colspan]="field.instructionColumns.length + 1" class="text-center text-muted">
                                    No data available
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <!-- Compound field type -->
                      <div
                        *ngIf="field.type === 'compound'"
                        class="compound-field"
                      >
                        <div
                          *ngFor="let subField of field.subFields"
                          class="sub-field mb-2"
                        >
                          <label class="form-label">
                            {{ subField.title }}
                            <span *ngIf="subField.required" class="text-danger ms-1">*</span>
                          </label>
                          <input
                            *ngIf="subField.type === 'number'"
                            type="number"
                            class="form-control"
                            [formControlName]="subField.name"
                            [placeholder]="
                              subField.unit
                                ? 'Enter value in ' + subField.unit
                                : 'Enter number'
                            "
                          />
                          <input
                            *ngIf="subField.type === 'text'"
                            type="text"
                            class="form-control"
                            [formControlName]="subField.name"
                          />
                        </div>
                      </div>
                      <!-- Calculated field type -->
                      <div
                        *ngIf="field.type === 'calculated'"
                        class="calculated-field"
                      >
                        <input
                          type="text"
                          class="form-control"
                          [formControlName]="field.name"
                          disabled
                          readonly
                          [placeholder]="'Calculated value will appear here'"
                        />
                        <small class="form-text text-muted"
                          >This field is automatically calculated</small
                        >
                      </div>
                      <!-- Table field type -->
                      <div *ngIf="field.type === 'table'" class="table-field">
                        <div
                          class="d-flex justify-content-between align-items-center mb-3"
                        >
                          <h6 class="table-head">{{ field.title }}</h6>
                          <div class="table-actions">
                            <button
                              type="button"
                              class="btn custom-button"
                              (click)="addTableRow(field.name)"
                              disabled
                            >
                              <i class="bx bx-plus"></i> Add Row
                            </button>
                          </div>
                        </div>
                        <div class="table-wrapper">
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th>Sr. No</th>
                                <th
                                  *ngFor="
                                    let column of field.columns;
                                    let colIndex = index
                                  "
                                >
                                  {{ column.title }}
                                  <span
                                    *ngIf="column.required"
                                    class="text-danger"
                                    >*</span
                                  >
                                </th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let row of getTableData(field.name);
                                  let rowIndex = index
                                "
                              >
                                <td class="text-center fw-bold">
                                  {{ rowIndex + 1 }}
                                </td>
                                <td
                                  *ngFor="
                                    let column of field.columns;
                                    let colIndex = index
                                  "
                                >
                                  <input
                                    *ngIf="column.type === 'text'"
                                    type="text"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                  />
                                  <input
                                    *ngIf="column.type === 'date'"
                                    type="date"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [max]="maxDate"
                                  />
                                  <input
                                    *ngIf="column.type === 'number'"
                                    type="number"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                  />
                                  <textarea
                                    *ngIf="column.type === 'textarea'"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                  ></textarea>
                                  <select
                                    *ngIf="column.type === 'dropdown'"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                  >
                                    <option value="">
                                      Select {{ column.title.toLowerCase() }}
                                    </option>
                                    <option
                                      *ngFor="let opt of column.values"
                                      [value]="opt.value"
                                    >
                                      {{ opt.label }}
                                    </option>
                                  </select>
                                  <input
                                    *ngIf="column.type === 'checkbox'"
                                    type="checkbox"
                                    class="form-check-input"
                                    [checked]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.checked
                                      )
                                    "
                                  />
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    class="btn btn-sm btn-danger"
                                    (click)="
                                      removeTableRow(field.name, rowIndex)
                                    "
                                  >
                                    <i class="bx bx-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- Empty state -->
                          <div
                            *ngIf="getTableData(field.name).length === 0"
                            class="text-center py-4"
                          >
                            <i class="bx bx-table display-4 text-muted"></i>
                            <p class="text-muted mt-2">
                              No data entered yet. Click "Add Row" to start.
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- Fixed Rows Table field type -->
                      <div *ngIf="field.type === 'fixed-rows-table'" class="table-field">
                        <div
                          class="d-flex justify-content-between align-items-center mb-3"
                        >
                          <h6 class="table-head">{{ field.title }}</h6>
                          <div class="table-actions">
                            <button
                              type="button"
                              class="btn custom-button"
                              (click)="addTableRow(field.name)"
                            >
                              <i class="bx bx-plus"></i> Add Row
                            </button>
                          </div>
                        </div>
                        <div class="table-wrapper">
                          <table class="table table-bordered">
                            <thead>
                              <tr>
                                <th *ngIf="getSrNoColumn(field)">{{ getSrNoColumn(field).title || 'Sr. No' }}</th>
                                <th
                                  *ngFor="
                                    let column of getTableColumnsExcludingSrNo(field);
                                    let colIndex = index
                                  "
                                >
                                  {{ column.title }}
                                  <span
                                    *ngIf="column.required"
                                    class="text-danger"
                                    >*</span
                                  >
                                </th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let row of getTableData(field.name);
                                  let rowIndex = index
                                "
                              >
                                <td *ngIf="getSrNoColumn(field)" class="text-center fw-bold">
                                  {{ rowIndex + 1 }}
                                </td>
                                <td
                                  *ngFor="
                                    let column of getTableColumnsExcludingSrNo(field);
                                    let colIndex = index
                                  "
                                >
                                  <!-- Statement type - displays like Sr. No -->
                                  <div
                                    *ngIf="column.type === 'statement'"
                                    class="text-center fw-bold"
                                    [style.padding]="'0.375rem 0.75rem'"
                                    [style.min-height]="'38px'"
                                    [style.display]="'flex'"
                                    [style.align-items]="'center'"
                                    [style.justify-content]="'center'"
                                  >
                                    {{
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      ) || '-'
                                    }}
                                  </div>
                                  <input
                                    *ngIf="column.type === 'text'"
                                    type="text"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  />
                                  <input
                                    *ngIf="column.type === 'date'"
                                    type="date"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [max]="maxDate"
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  />
                                  <input
                                    *ngIf="column.type === 'number'"
                                    type="number"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  />
                                  <textarea
                                    *ngIf="column.type === 'textarea'"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (input)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [placeholder]="
                                      'Enter ' + column.title.toLowerCase()
                                    "
                                    [readonly]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                    [style.background-color]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0) ? '#e9ecef' : ''"
                                  ></textarea>
                                  <select
                                    *ngIf="column.type === 'dropdown'"
                                    class="form-control"
                                    [value]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.value
                                      )
                                    "
                                    [disabled]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                  >
                                    <option value="">
                                      Select {{ column.title.toLowerCase() }}
                                    </option>
                                    <option
                                      *ngFor="let opt of column.values"
                                      [value]="opt.value"
                                    >
                                      {{ opt.label }}
                                    </option>
                                  </select>
                                  <input
                                    *ngIf="column.type === 'checkbox'"
                                    type="checkbox"
                                    class="form-check-input"
                                    [checked]="
                                      getTableCellValue(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex
                                      )
                                    "
                                    (change)="
                                      updateTableCell(
                                        field.name,
                                        rowIndex,
                                        column.name || 'col_' + colIndex,
                                        $event.target.checked
                                      )
                                    "
                                    [disabled]="field.type === 'fixed-rows-table' && (column.isSecondColumn || colIndex === 0)"
                                  />
                                </td>
                                <td>
                                  <div class="d-flex gap-2">
                                    <button
                                      *ngIf="field.type === 'fixed-rows-table'"
                                      type="button"
                                      class="btn btn-sm btn-primary"
                                      (click)="
                                        openEditStatementModal(field.name, rowIndex)
                                      "
                                      title="Edit Statement Values"
                                    >
                                      <i class="bx bx-edit"></i>
                                    </button>
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-danger"
                                      (click)="
                                        removeTableRow(field.name, rowIndex)
                                      "
                                      title="Remove Row"
                                    >
                                      <i class="bx bx-trash"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- Empty state -->
                          <div
                            *ngIf="getTableData(field.name).length === 0"
                            class="text-center py-4"
                          >
                            <i class="bx bx-table display-4 text-muted"></i>
                            <p class="text-muted mt-2">
                              No data entered yet. Click "Add Row" to start.
                            </p>
                          </div>
                        </div>
                      </div>
                      <!-- Conditional Navigation Buttons -->
                      <div
                        class="mt-3"
                        *ngIf="
                          field.type === 'radio' || field.type === 'dropdown'
                        "
                      >
                        <!-- Adverse Events Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'adverse-events')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            (click)="navigateToAdverseEvents()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Adverse Events
                            Data
                          </button>
                        </div>
                        <!-- Laboratory Investigation Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'laboratory')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToLaboratory()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Laboratory Data
                          </button>
                        </div>
                        <!-- Physical Examination Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'physical')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToPhysicalSystemic()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Physical
                            Examination Data
                          </button>
                        </div>
                        <!-- IDRS Assessment Navigation -->
                        <div
                          *ngIf="shouldShowNavigation(field, 'idrs')"
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-secondary btn-sm"
                            (click)="navigateToIDRS()"
                          >
                            <i class="bx bx-plus me-1"></i>Add IDRS Assessment
                            Data
                          </button>
                        </div>
                        <!-- Prior Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-dark btn-sm"
                            (click)="navigateToPriorMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Prior Medication
                            Data
                          </button>
                        </div>
                        <!-- Concomitant Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            (click)="navigateToConcomitantMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Concomitant
                            Medication Data
                          </button>
                        </div>
                        <!-- Rescue Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-warning btn-sm"
                            (click)="navigateToRescueMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Rescue Medication
                            Data
                          </button>
                        </div>
                        <!-- Medical History Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('medical history') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-info btn-sm"
                            (click)="navigateToMedicalHistory()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Medical History
                            Data
                          </button>
                        </div>
                        <!-- Baseline Physical Exam Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('physical') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToBaselinePhysicalExam()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Baseline Physical
                            Exam Data
                          </button>
                        </div>
                        <!-- Baseline Lab Investigation Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('laboratory') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToBaselineLabInvestigation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Baseline
                            Laboratory Data
                          </button>
                        </div>
                        <!-- Follow-up Physical Exam Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('physical') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-primary btn-sm"
                            (click)="navigateToFollowUpPhysical()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Follow-up
                            Physical Exam Data
                          </button>
                        </div>
                        <!-- Follow-up Lab Investigation Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('laboratory') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToFollowUpLabInvestigation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Follow-up
                            Laboratory Data
                          </button>
                        </div>
                        <!-- Medicine Dispensing Vital Signs Navigation -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('medicine') &&
                            field.title.toLowerCase().includes('vital signs') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-success btn-sm"
                            (click)="navigateToMedicineVitalSigns()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Medicine
                            Dispensing Vital Signs Data
                          </button>
                        </div>
                        <!-- Adverse Events Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('adverse event') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            (click)="navigateToAdverseEvents()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Adverse Events
                            Data
                          </button>
                        </div>
                        <!-- Concomitant Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-info btn-sm"
                            (click)="navigateToConcomitantMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Concomitant
                            Medication Data
                          </button>
                        </div>
                        <!-- Rescue Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-warning btn-sm"
                            (click)="navigateToRescueMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Rescue Medication
                            Data
                          </button>
                        </div>
                        <!-- Prior Medication Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-info btn-sm"
                            (click)="navigateToPriorMedication()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Prior Medication
                            Data
                          </button>
                        </div>
                        <!-- Protocol Deviation Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('protocol deviation') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-danger btn-sm"
                            (click)="navigateToProtocolDeviation()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Protocol
                            Deviation Data
                          </button>
                        </div>
                        <!-- Study Completion Navigation -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('study completion') &&
                            getFieldValue(field.name) === 'yes'
                          "
                          class="mb-2"
                        >
                          <button
                            type="button"
                            class="btn btn-outline-success btn-sm"
                            (click)="navigateToStudyCompletion()"
                          >
                            <i class="bx bx-plus me-1"></i>Add Study Completion
                            Data
                          </button>
                        </div>
                      </div>
                      <!-- Conditional Comment Fields for "No" answers -->
                      <div
                        class="mt-3"
                        *ngIf="
                          field.type === 'radio' &&
                          getFieldValue(field.name) === 'no'
                        "
                      >
                        <!-- Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[field.name + '_vitalSignsComments']
                            "
                            name="vitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Physical Examination Comments -->
                        <div
                          *ngIf="field.title.toLowerCase().includes('physical')"
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_physicalExamComments'
                              ]
                            "
                            name="physicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing physical examination..."
                          >
                          </textarea>
                        </div>
                        <!-- IDRS Assessment Comments -->
                        <div
                          *ngIf="field.title.toLowerCase().includes('idrs')"
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_idrsAssessmentComments'
                              ]
                            "
                            name="idrsAssessmentComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing IDRS assessment..."
                          >
                          </textarea>
                        </div>
                        <!-- Laboratory Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_labInvestigationComments'
                              ]
                            "
                            name="labInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing laboratory investigation..."
                          >
                          </textarea>
                        </div>
                        <!-- Baseline Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselineVitalSignsComments'
                              ]
                            "
                            name="baselineVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Baseline Physical Exam Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('physical')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselinePhysicalExamComments'
                              ]
                            "
                            name="baselinePhysicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline physical examination..."
                          >
                          </textarea>
                        </div>
                        <!-- Baseline Lab Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('baseline') &&
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_baselineLabInvestigationComments'
                              ]
                            "
                            name="baselineLabInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing baseline laboratory investigation..."
                          >
                          </textarea>
                        </div>
                        <!-- Follow-up Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpVitalSignsComments'
                              ]
                            "
                            name="followUpVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Follow-up Physical Exam Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('physical')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpPhysicalExamComments'
                              ]
                            "
                            name="followUpPhysicalExamComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up physical examination..."
                          >
                          </textarea>
                        </div>
                        <!-- Follow-up Lab Investigation Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('follow') &&
                            field.title.toLowerCase().includes('laboratory')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_followUpLabInvestigationComments'
                              ]
                            "
                            name="followUpLabInvestigationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing follow-up laboratory investigation..."
                          >
                          </textarea>
                        </div>
                        <!-- Medicine Dispensing Vital Signs Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('medicine') &&
                            field.title.toLowerCase().includes('vital signs')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_medicineVitalSignsComments'
                              ]
                            "
                            name="medicineVitalSignsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not performing medicine dispensing vital signs evaluation..."
                          >
                          </textarea>
                        </div>
                        <!-- Adverse Events Comments -->
                        <div
                          *ngIf="
                            field.title.toLowerCase().includes('adverse event')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_adverseEventsComments'
                              ]
                            "
                            name="adverseEventsComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording adverse events..."
                          >
                          </textarea>
                        </div>
                        <!-- Concomitant Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('concomitant medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_concomitantMedicationComments'
                              ]
                            "
                            name="concomitantMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording concomitant medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Rescue Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('rescue medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_rescueMedicationComments'
                              ]
                            "
                            name="rescueMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording rescue medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Prior Medication Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('prior medication')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_priorMedicationComments'
                              ]
                            "
                            name="priorMedicationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording prior medication..."
                          >
                          </textarea>
                        </div>
                        <!-- Protocol Deviation Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('protocol deviation')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_protocolDeviationComments'
                              ]
                            "
                            name="protocolDeviationComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not recording protocol deviation..."
                          >
                          </textarea>
                        </div>
                        <!-- Study Completion Comments -->
                        <div
                          *ngIf="
                            field.title
                              .toLowerCase()
                              .includes('study completion')
                          "
                          class="mb-2"
                        >
                          <label class="form-label"
                            >Please provide comments:</label
                          >
                          <textarea
                            class="form-control"
                            [(ngModel)]="
                              commentFields[
                                field.name + '_studyCompletionComments'
                              ]
                            "
                            name="studyCompletionComments"
                            required
                            rows="3"
                            placeholder="Please provide reason for not completing study..."
                          >
                          </textarea>
                        </div>
                      </div>
                      <!-- Sub Header display - at the end after everything (fieldname, fieldtype, inputs, navigation, comments, attachments) -->
                      <div *ngIf="field.subHeader && field.type !== 'instruction'" class="mb-2 mt-2" style="font-size: 14px; color: #6c757d; font-style: italic;">
                        <strong>Note:</strong> {{ field.subHeader }}
                      </div>
                    </div>
                  </ng-container>
                </div>
                <!-- Empty state for fields -->
                <div class="text-center py-4" *ngIf="fields.length === 0">
                  <i class="bx bx-file display-6 text-muted"></i>
                  <div class="text-muted">
                    No fields yet. Click "Create Field" to add fields.
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between align-items-center mt-3"
                  *ngIf="fields.length > 0"
                >
                  <!-- PI Signature Checkbox -->
                  <div class="pi-signature-section">
                    <div *ngIf="SignatureCheck()" class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="piSignatureCheckbox"
                        [checked]="getPiSignatureReviewed()"
                        (change)="setPiSignatureReviewed($event.target.checked)"
                        name="piSignatureReviewed"
                      />
                      <label
                        class="form-check-label fw-bold"
                        for="piSignatureCheckbox"
                      >
                        Reviewed by PI Signature
                      </label>
                    </div>
                  </div>
                  <!-- Done Button for Fields -->
                  <!-- <div>
                    <button
                      class="btn custom-button"
                      (click)="doneFields()"
                      [disabled]="!fields || fields.length === 0"
                    >
                      Done
                    </button>
                  </div> -->
                </div>
              </form>
            </div>
          </div>
          <!-- No form selected state -->
          <div class="text-center py-5" *ngIf="!currentForm">
            <i class="bx bx-file display-1 text-muted"></i>
            <h5 class="mt-3">No Form Selected</h5>
            <p class="text-muted">
              Select a form from the sidebar to view and edit its fields.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Create Form Modal -->
<div
  class="modal"
  *ngIf="showCreateFormModal"
  (click)="showCreateFormModal = false"
>
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content create-form-modal p-4">
      <h5 class="modal-title">Create New Form</h5>
      <div class="mb-3">
        <label class="form-label">Form Name:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="newFormName"
          placeholder="Enter form name"
          (keyup.enter)="createForm()"
        />
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn custom-button me-2"
          (click)="showCreateFormModal = false"
        >
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="createForm()"
          [disabled]="!newFormName.trim()"
        >
          Create
        </button>
      </div>
    </div>
  </div>
</div>

                      <!-- Review Modal -->
                      <div
                        class="modal-overlay1"
                        *ngIf="showReviewModal"
                        [style.top]="reviewModalPosition.top"
  [style.right]="reviewModalPosition.right"
                        (click)="closeReviewModal()"
                      >
                        <!-- Close Button -->
                        <span class="close-button1" (click)="closeReviewModal()"
                          >×</span
                        >
                        <div
                          class="modal-content1"
                          (click)="$event.stopPropagation()"
                        >
                          <div class="checkbox-group">
                            <div class="form-check" style="margin-top: 20px">
                              <input
                                type="checkbox"
                                id="reviewedByDataMonitor"
                                name="reviewedByDataMonitor"
                                [checked]="reviewOptions.dataMonitor"
                                (change)="
                                  reviewOptions.dataMonitor =
                                    $event.target.checked;
                                  onReviewCheckboxChange()
                                "
                              />
                              <label for="reviewedByDataMonitor"
                                >Reviewed by Data Manager</label
                              >
                            </div>
                          </div>
                          <div class="checkbox-group">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                id="reviewedByMonitor"
                                name="reviewedByMonitor"
                                [checked]="reviewOptions.monitor"
                                (change)="
                                  reviewOptions.monitor = $event.target.checked;
                                  onReviewCheckboxChange()
                                "
                              />
                              <label for="reviewedByMonitor"
                                >Reviewed by Monitor</label
                              >
                            </div>
                          </div>
                          <div class="checkbox-group">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                id="reviewedByPI"
                                name="reviewedByPI"
                                [checked]="reviewOptions.pi"
                                (change)="
                                  reviewOptions.pi = $event.target.checked;
                                  onReviewCheckboxChange()
                                "
                              />
                              <label for="reviewedByPI">Reviewed by PI</label>
                            </div>
                          </div>
                        </div>
                      </div>

<!-- Create Field Modal -->
<div
  class="modal"
  *ngIf="showCreateFieldModal"
  (click)="closeCreateFieldModal()"
>
  <div
    class="modal-dialog"
    (click)="$event.stopPropagation()"
    [ngClass]="{ 'table-modal': newField.type === 'table' || newField.type === 'fixed-rows-table' }"
  >
    <div class="modal-content edit-field-modal p-4">
      <h5 class="modal-title">
        {{ isEditMode ? "Edit Field" : "Create New Field" }}
      </h5>
      <div class="mb-3">
        <label class="form-label">Field Name:</label>
        <input
          class="form-control"
          [(ngModel)]="newField.title"
          placeholder="Enter field name"
        />
      </div>
      <div class="mb-3">
        <label class="form-label">Field Type:</label>
        <select class="form-control cursor-pointer" [(ngModel)]="newField.type" (change)="onFieldTypeChange()">
          <option value="">Select</option>
          <option value="text">Text Input</option>
          <option value="date">Date</option>
          <option value="time">Time</option>
          <option value="number">Number</option>
          <option value="radio">Radio</option>
          <option value="checkbox">Checkboxes</option>
          <option value="textarea">Textarea</option>
          <option value="dropdown">Dropdown</option>
          <option value="esignature">E-signature</option>
          <option value="title">Section Title</option>
          <option value="instruction">Instruction</option>
          <!-- <option value="calculated">Calculated</option>
        <option value="compound">Compound</option> -->
          <option value="table">Table</option>
          <option value="fixed-rows-table">Fixed Rows Table</option>
        </select>
      </div>
      <div class="mb-3" *ngIf="newField.type !== 'instruction'">
        <label class="form-label">Sub Header:</label>
        <input
          class="form-control"
          [(ngModel)]="newField.subHeader"
          placeholder="Enter sub header (optional)"
        />
      </div>
      <div class="mb-3" *ngIf="newField.type !== 'instruction'">
        <label class="form-label">Is this field optional?</label>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="newField.optional"
            (ngModelChange)="newField.required = !$event"
          />
          <label class="form-check-label">Yes</label>
        </div>
      </div>
      <div class="mb-3" *ngIf="newField.type !== 'instruction'">
        <label class="form-label">Attachment Required?</label>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="newField.attachmentRequired"
          />
          <label class="form-check-label">Yes</label>
        </div>
      </div>
      <!-- Conversion configuration (primarily for numeric fields) -->
      <div class="mb-3" *ngIf="newField.type !== 'instruction'">
        <label class="form-label">Conversion required?</label>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="newField.conversionRequired"
          />
          <label class="form-check-label">Yes</label>
        </div>
      </div>
      <div
        class="mb-3"
        *ngIf="newField.conversionRequired && newField.type !== 'instruction'"
      >
        <label class="form-label">Type of conversion &amp; units</label>
        <div class="row g-2">
          <div class="col-md-4">
            <select
              class="form-control"
              [(ngModel)]="newField.conversionType"
              (ngModelChange)="onConversionTypeChange()"
            >
              <option value="">Select type</option>
              <option
                *ngFor="let type of conversionTypes"
                [value]="type.key"
              >
                {{ type.label }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <select
              class="form-control"
              [(ngModel)]="newField.conversionFromUnit"
            >
              <option value="">From unit</option>
              <option
                *ngFor="let unit of getUnitsForConversionType(newField.conversionType)"
                [value]="unit.value"
              >
                {{ unit.label }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <select
              class="form-control"
              [(ngModel)]="newField.conversionToUnit"
            >
              <option value="">To unit</option>
              <option
                *ngFor="let unit of getUnitsForConversionType(newField.conversionType)"
                [value]="unit.value"
              >
                {{ unit.label }}
              </option>
            </select>
          </div>
        </div>
        <small class="text-muted">
          Example: weight in kg → grams, temperature in °C → °F.
        </small>
      </div>
      <!-- Dependency Configuration -->
      <div class="mb-3" *ngIf="newField.type !== 'instruction'">
        <label class="form-label">Is it a dependent field?</label>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="newField.hasDependency"
            (change)="onDependencyToggle()"
          />
          <label class="form-check-label">Yes</label>
        </div>
      </div>
      <!-- Dependency Configuration Panel -->
      <div
        class="mb-3"
        *ngIf="newField.hasDependency && newField.type !== 'instruction'"
        style="
          border: 1px solid #e0e0e0;
          padding: 15px;
          border-radius: 5px;
          background-color: #f9f9f9;
        "
      >
        <h6 class="mb-3">Dependency Configuration</h6>
        <!-- Folder Selection -->
        <div class="mb-3">
          <label class="form-label">Select Folder:</label>
          <select
            class="form-control"
            [(ngModel)]="newField.dependency.folderId"
            (change)="onFolderChange()"
          >
            <option value="">Select Folder</option>
            <option *ngFor="let folder of availableFolders" [value]="folder.id">
              {{ folder.name }}
            </option>
          </select>
        </div>
        <!-- Form Selection -->
        <div class="mb-3" *ngIf="newField.dependency.folderId">
          <label class="form-label">Select Form:</label>
          <select
            class="form-control"
            [(ngModel)]="newField.dependency.formId"
            (change)="onFormChange()"
          >
            <option value="">Select Form</option>
            <option *ngFor="let form of availableForms" [value]="form.id">
              {{ form.name }}
            </option>
          </select>
        </div>
        <!-- Field Selection -->
        <div class="mb-3" *ngIf="newField.dependency.formId">
          <label class="form-label">Select Field:</label>
          <select
            class="form-control"
            [(ngModel)]="newField.dependency.fieldId"
            (change)="onFieldChange()"
          >
            <option value="">Select Field</option>
            <option *ngFor="let field of availableFields" [value]="field.id">
              {{ field.title }}
            </option>
          </select>
        </div>
        <!-- Dependency Value Selection -->
        <div
          class="mb-3"
          *ngIf="newField.dependency.fieldId && selectedDependencyField"
        >
          <div class="alert alert-info mb-2">
            <small
              ><strong>Selected Field:</strong>
              {{ selectedDependencyField.title }} ({{
                selectedDependencyField.type
              }})</small
            >
            <br />
            <small
              *ngIf="
                selectedDependencyField.options &&
                selectedDependencyField.options.length > 0
              "
            >
              <strong>Available Options:</strong>
              {{ selectedDependencyField.options.join(", ") }}
            </small>
            <small
              *ngIf="
                !selectedDependencyField.options ||
                selectedDependencyField.options.length === 0
              "
            >
              <strong>No predefined options available</strong>
            </small>
          </div>
          <ng-container
            *ngIf="
              selectedDependencyField &&
              !['table', 'esignature', 'signature', 'title', 'instruction'].includes(
                (selectedDependencyField.type || '').toLowerCase()
              )
            "
          >
            <label class="form-label"
              >Show this field when dependency field value is:</label
            >
            <!-- Yes/No trigger for radio/dropdown/select fields -->
            <div
            *ngIf="
              (selectedDependencyField.type === 'radio' ||
                selectedDependencyField.type === 'radio-button' ||
                selectedDependencyField.type === 'dropdown' ||
                selectedDependencyField.type === 'select') &&
              selectedDependencyField.options &&
              selectedDependencyField.options.length === 2 &&
              ((selectedDependencyField.options[0]?.toLowerCase() === 'yes' &&
                selectedDependencyField.options[1]?.toLowerCase() === 'no') ||
                (selectedDependencyField.options[0]?.toLowerCase() === 'no' &&
                  selectedDependencyField.options[1]?.toLowerCase() === 'yes'))
            "
          >
            <div class="form-check-group">
              <div class="form-check">
                <input
                  type="radio"
                  class="form-check-input"
                  [name]="'triggerValueYesNo_' + (selectedDependencyField?.id || 'dep')"
                  value="Yes"
                  [(ngModel)]="newField.dependency.triggerValue"
                  id="triggerYes"
                />
                <label class="form-check-label" for="triggerYes">Yes</label>
              </div>
              <div class="form-check">
                <input
                  type="radio"
                  class="form-check-input"
                  [name]="'triggerValueYesNo_' + (selectedDependencyField?.id || 'dep')"
                  value="No"
                  [(ngModel)]="newField.dependency.triggerValue"
                  id="triggerNo"
                />
                <label class="form-check-label" for="triggerNo">No</label>
              </div>
            </div>
            <small class="text-muted"
              >Select whether this field should appear when the dependency field
              is "Yes" or "No"</small
            >
            </div>
            <div
            *ngIf="
              (selectedDependencyField.type === 'radio-button' ||
                selectedDependencyField.type === 'dropdown' ||
                selectedDependencyField.type === 'radio' ||
                selectedDependencyField.type === 'select') &&
              !(
                selectedDependencyField.options &&
                selectedDependencyField.options.length === 2 &&
                ((selectedDependencyField.options[0]?.toLowerCase() === 'yes' &&
                  selectedDependencyField.options[1]?.toLowerCase() === 'no') ||
                  (selectedDependencyField.options[0]?.toLowerCase() === 'no' &&
                    selectedDependencyField.options[1]?.toLowerCase() === 'yes'))
              )
            "
          >
            <select
              *ngIf="
                selectedDependencyField.options &&
                selectedDependencyField.options.length > 0
              "
              class="form-control"
              [(ngModel)]="newField.dependency.triggerValue"
            >
              <option value="">Select Value</option>
              <option
                *ngFor="let option of selectedDependencyField.options"
                [value]="option"
              >
                {{ option }}
              </option>
            </select>
            <input
              *ngIf="
                !selectedDependencyField.options ||
                selectedDependencyField.options.length === 0
              "
              type="text"
              class="form-control"
              [(ngModel)]="newField.dependency.triggerValue"
              placeholder="Enter trigger value"
            />
            <small class="text-muted"
              >Select or enter the value that should trigger this field to
              appear</small
            >
            </div>
            <div
            *ngIf="
              selectedDependencyField.type === 'checkbox-group' ||
              selectedDependencyField.type === 'checkbox'
            "
          >
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [(ngModel)]="newField.dependency.triggerValue"
              />
              <label class="form-check-label">Checked</label>
            </div>
            <small class="text-muted"
              >This field will appear when the checkbox is checked</small
            >
            </div>
            <div
            *ngIf="
              selectedDependencyField.type === 'text' ||
              selectedDependencyField.type === 'textarea'
            "
          >
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newField.dependency.triggerValue"
              placeholder="Enter trigger value"
            />
            <small class="text-muted"
              >Enter the exact text value that should trigger this field</small
            >
            </div>
            <div *ngIf="selectedDependencyField.type === 'number'">
            <input
              type="number"
              class="form-control"
              [(ngModel)]="newField.dependency.triggerValue"
              placeholder="Enter trigger number"
            />
            <small class="text-muted"
              >Enter the number value that should trigger this field</small
            >
            </div>
            <div *ngIf="selectedDependencyField.type === 'date'">
            <input
              type="date"
              class="form-control"
              [(ngModel)]="newField.dependency.triggerValue"
              [max]="maxDate"
            />
            <small class="text-muted"
              >Select the date that should trigger this field</small
            >
            </div>
          </ng-container>
        </div>
      </div>
      <!-- Validation Check Configuration -->
      <div class="mb-3" *ngIf="newField.type !== 'instruction' && newField.type !== 'title' && newField.type !== 'esignature'">
        <label class="form-label">Add Validation Check?</label>
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="newField.hasValidation"
            (change)="onValidationToggle()"
          />
          <label class="form-check-label">Yes</label>
        </div>
      </div>
      <!-- Validation Configuration Panel -->
      <div
        class="mb-3"
        *ngIf="newField.hasValidation && newField.type !== 'instruction' && newField.type !== 'title' && newField.type !== 'esignature'"
        style="
          border: 1px solid #e0e0e0;
          padding: 15px;
          border-radius: 5px;
          background-color: #f9f9f9;
        "
      >
        <h6 class="mb-3">Validation Configuration</h6>
        <!-- Validation Type Selection (multiple) -->
        <div class="mb-3">
          <label class="form-label">Validation types (select one or more):</label>
          <div class="d-flex flex-column gap-2">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="validationTypeRangeLimit"
                [checked]="hasValidationType('range-limit-check')"
                (change)="toggleValidationType('range-limit-check')"
              />
              <label class="form-check-label" for="validationTypeRangeLimit">Range / Limit Check Queries</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="validationTypeMissingData"
                [checked]="hasValidationType('missing-data-queries')"
                (change)="toggleValidationType('missing-data-queries')"
              />
              <label class="form-check-label" for="validationTypeMissingData">Missing Data Queries</label>
            </div>
          </div>
        </div>

        <!-- ========== Range / Limit Check Queries ========== -->
        <ng-container *ngIf="hasValidationType('range-limit-check')">
          <h6 class="mb-2 mt-3 text-primary border-bottom pb-2">Range / Limit Check Queries</h6>
          <!-- Field Selection: This Field or Dependent Field (for Range/Limit Check) -->
          <div class="mb-3">
            <label class="form-label">Apply validation to:</label>
            <select
              class="form-control"
              [(ngModel)]="newField.validation.fieldSelection"
              (change)="onValidationFieldSelectionChange()"
            >
              <option value="">Select</option>
              <option value="this-field">This Field</option>
              <option value="dependent-field">Dependent Field</option>
            </select>
          </div>
          <!-- Dependent Field Selection (Folder, Form, Field) -->
        <div
          *ngIf="newField.validation.fieldSelection === 'dependent-field' && hasValidationType('range-limit-check')"
        >
          <!-- Folder Selection -->
          <div class="mb-3">
            <label class="form-label">Select Folder:</label>
            <select
              class="form-control"
              [(ngModel)]="newField.validation.dependency.folderId"
              (change)="onValidationFolderChange()"
            >
              <option value="">Select Folder</option>
              <option *ngFor="let folder of availableFolders" [value]="folder.id">
                {{ folder.name }}
              </option>
            </select>
          </div>
          <!-- Form Selection -->
          <div class="mb-3" *ngIf="newField.validation.dependency.folderId">
            <label class="form-label">Select Form:</label>
            <select
              class="form-control"
              [(ngModel)]="newField.validation.dependency.formId"
              (change)="onValidationFormChange()"
            >
              <option value="">Select Form</option>
              <option *ngFor="let form of availableValidationForms" [value]="form.id">
                {{ form.name }}
              </option>
            </select>
          </div>
          <!-- Field Selection -->
          <div class="mb-3" *ngIf="newField.validation.dependency.formId">
            <label class="form-label">Select Field:</label>
            <select
              class="form-control"
              [(ngModel)]="newField.validation.dependency.fieldId"
              (change)="onValidationFieldChange()"
            >
              <option value="">Select Field</option>
              <option *ngFor="let field of availableValidationFields" [value]="field.id || field.name">
                {{ field.title }}
              </option>
            </select>
          </div>

          <!-- Validation Field Value Selection (like dependency) - for Range/Limit only -->
          <div
            class="mb-3"
            *ngIf="newField.validation.dependency.fieldId && selectedValidationField && hasValidationType('range-limit-check')"
          >
            <div class="alert alert-info mb-2">
              <small
                ><strong>Selected Field:</strong>
                {{ selectedValidationField.title }} ({{
                  selectedValidationField.type
                }})</small
              >
              <br />
              <small
                *ngIf="
                  selectedValidationField.options &&
                  selectedValidationField.options.length > 0
                "
              >
                <strong>Available Options:</strong>
                {{ selectedValidationField.options.join(', ') }}
              </small>
              <small
                *ngIf="
                  !selectedValidationField.options ||
                  selectedValidationField.options.length === 0
                "
              >
                <strong>No predefined options available</strong>
              </small>
            </div>

            <ng-container
              *ngIf="
                selectedValidationField &&
                !['table', 'esignature', 'signature', 'title', 'instruction'].includes(
                  (selectedValidationField.type || '').toLowerCase()
                )
              "
            >
              <label class="form-label"
                >Apply this validation when selected field value is:</label
              >

              <!-- Yes/No trigger for radio/dropdown/select fields -->
              <div
                *ngIf="
                  (selectedValidationField.type === 'radio' ||
                    selectedValidationField.type === 'radio-button' ||
                    selectedValidationField.type === 'dropdown' ||
                    selectedValidationField.type === 'select') &&
                  selectedValidationField.options &&
                  selectedValidationField.options.length === 2 &&
                  ((selectedValidationField.options[0]?.toLowerCase() === 'yes' &&
                    selectedValidationField.options[1]?.toLowerCase() === 'no') ||
                    (selectedValidationField.options[0]?.toLowerCase() === 'no' &&
                      selectedValidationField.options[1]?.toLowerCase() === 'yes'))
                "
              >
                <div class="form-check-group">
                  <div class="form-check">
                    <input
                      type="radio"
                      class="form-check-input"
                      [name]="'validationTriggerYesNo_' + (selectedValidationField?.id || 'val')"
                      value="Yes"
                      [(ngModel)]="newField.validation.dependency.triggerValue"
                      id="validationTriggerYes"
                    />
                    <label class="form-check-label" for="validationTriggerYes"
                      >Yes</label
                    >
                  </div>
                  <div class="form-check">
                    <input
                      type="radio"
                      class="form-check-input"
                      [name]="'validationTriggerYesNo_' + (selectedValidationField?.id || 'val')"
                      value="No"
                      [(ngModel)]="newField.validation.dependency.triggerValue"
                      id="validationTriggerNo"
                    />
                    <label class="form-check-label" for="validationTriggerNo"
                      >No</label
                    >
                  </div>
                </div>
                <small class="text-muted"
                  >Select whether this validation should apply when the selected
                  field is "Yes" or "No"</small
                >
              </div>

              <div
                *ngIf="
                  (selectedValidationField.type === 'radio-button' ||
                    selectedValidationField.type === 'dropdown' ||
                    selectedValidationField.type === 'radio' ||
                    selectedValidationField.type === 'select') &&
                  !(
                    selectedValidationField.options &&
                    selectedValidationField.options.length === 2 &&
                    ((selectedValidationField.options[0]?.toLowerCase() === 'yes' &&
                      selectedValidationField.options[1]?.toLowerCase() === 'no') ||
                      (selectedValidationField.options[0]?.toLowerCase() === 'no' &&
                        selectedValidationField.options[1]?.toLowerCase() === 'yes'))
                  )
                "
              >
                <select
                  *ngIf="
                    selectedValidationField.options &&
                    selectedValidationField.options.length > 0
                  "
                  class="form-control"
                  [(ngModel)]="newField.validation.dependency.triggerValue"
                >
                  <option value="">Select Value</option>
                  <option
                    *ngFor="let option of selectedValidationField.options"
                    [value]="option"
                  >
                    {{ option }}
                  </option>
                </select>
                <input
                  *ngIf="
                    !selectedValidationField.options ||
                    selectedValidationField.options.length === 0
                  "
                  type="text"
                  class="form-control"
                  [(ngModel)]="newField.validation.dependency.triggerValue"
                  placeholder="Enter trigger value"
                />
                <small class="text-muted"
                  >Select or enter the value that should trigger this validation to
                  apply</small
                >
              </div>

              <div
                *ngIf="
                  (selectedValidationField.type || '').toLowerCase() === 'checkbox-group' ||
                  (selectedValidationField.type || '').toLowerCase() === 'checkbox'
                "
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="newField.validation.dependency.triggerValue"
                  />
                  <label class="form-check-label">Checked</label>
                </div>
                <small class="text-muted"
                  >This validation will apply when the checkbox is checked</small
                >
              </div>

              <div
                *ngIf="
                  (selectedValidationField.type || '').toLowerCase() === 'text' ||
                  (selectedValidationField.type || '').toLowerCase() === 'textarea'
                "
              >
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="newField.validation.dependency.triggerValue"
                  placeholder="Enter trigger value"
                />
              </div>

              <!-- For number fields, skip trigger value - min/max will be shown directly -->

              <div *ngIf="selectedValidationField.type === 'date'">
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="newField.validation.dependency.triggerValue"
                  [max]="maxDate"
                />
              </div>
            </ng-container>
          </div>
        </div>
          <!-- Range/Limit Check: Min, Max, Query Message (always visible when this type is selected) -->
          <div class="mb-3">
            <label class="form-label">Minimum Value:</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newField.validation.rangeLimitCheck.minValue"
              inputmode="numeric"
              pattern="^[0-9]+(\/[0-9]+)?$"
              placeholder="Enter minimum value (e.g., 10 or 90/60)"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Maximum Value:</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newField.validation.rangeLimitCheck.maxValue"
              inputmode="numeric"
              pattern="^[0-9]+(\/[0-9]+)?$"
              placeholder="Enter maximum value (e.g., 100 or 140/90)"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Query Message (Range / Limit Check):</label>
            <textarea
              class="form-control"
              [(ngModel)]="newField.validation.rangeLimitCheck.queryMessage"
              placeholder="Enter the query message that will be displayed when validation fails"
              rows="3"
            ></textarea>
            <small class="form-text text-muted">
              This query will be automatically raised when entered values fall outside the predefined minimum–maximum limits
            </small>
          </div>
        </ng-container>

        <!-- ========== Missing Data Queries ========== -->
        <div *ngIf="hasValidationType('missing-data-queries')">
          <h6 class="mb-2 mt-3 text-primary border-bottom pb-2">Missing Data Queries</h6>
          <div class="alert alert-info mb-3">
            <small>
              <strong>Trigger:</strong> Triggered when a required field is left blank or a mandatory form/visit is incomplete.
              At data entry, if this required field is blank, a query will be raised at study level.
            </small>
          </div>
          <div class="mb-3">
            <label class="form-label">Start Date:</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="newField.validation.missingDataQueries.startDate"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">End Date:</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="newField.validation.missingDataQueries.endDate"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Buffer:</label>
            <input
              type="number"
              class="form-control"
              [(ngModel)]="newField.validation.missingDataQueries.buffer"
              placeholder="Enter buffer value"
              min="0"
              step="1"
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Query Message (Missing Data):</label>
            <textarea
              class="form-control"
              [(ngModel)]="newField.validation.missingDataQueries.queryMessage"
              placeholder="Enter the query message to display when this required field is left blank"
              rows="3"
            ></textarea>
            <small class="form-text text-muted">
              This query will be raised when the mandatory field is left blank or the form/visit is incomplete.
            </small>
          </div>
        </div>
      </div>
      <!-- Options editor: visible for select/radio/checkbox/dropdown -->
      <div
        class="mb-3"
        *ngIf="
          newField.type === 'select' ||
          newField.type === 'dropdown' ||
          newField.type === 'radio' ||
          newField.type === 'checkbox'
        "
      >
        <label class="form-label">Options</label>
        <div class="input-group mb-2">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newOptionText"
            placeholder="Add option"
            (keyup.enter)="addOption()"
          />
          <button class="btn custom-button" type="button" (click)="addOption()">
            Add
          </button>
        </div>
        <div *ngIf="newField.options?.length" class="d-flex flex-wrap gap-2">
          <span
            class="badge bg-secondary d-flex align-items-center"
            *ngFor="let opt of newField.options; let oi = index"
            style="background-color: #e2dae8 !important; color: #2b124c"
          >
            <span class="me-2">{{ opt }}</span>
            <button type="button" class="cross-btn" (click)="removeOption(oi)">
              x
            </button>
          </span>
        </div>
      </div>
      <!-- Instruction editor: visible for instruction type -->
      <div class="mb-3" *ngIf="newField.type === 'instruction'">
        <label class="form-label">Instruction Content</label>
        <!-- Text Instructions -->
        <div class="mb-3">
          <label class="form-label">Text Instructions:</label>
          <textarea
            class="form-control"
            [(ngModel)]="newField.instructionText"
            placeholder="Enter instructions or description"
            rows="4"
          ></textarea>
        </div>
        <!-- Image Upload Section -->
        <div class="mb-3">
          <label class="form-label">Images (Optional):</label>
          <input
            type="file"
            class="form-control"
            accept="image/*"
            multiple
            (change)="onInstructionImageSelected($event)"
            id="instructionImageInput"
          />
          <small class="form-text text-muted">
            You can upload one or more images to accompany the instructions
          </small>
          <!-- Display uploaded images -->
          <div *ngIf="newField.instructionImages && newField.instructionImages.length > 0" class="mt-3">
            <div class="row">
              <div
                *ngFor="let image of newField.instructionImages; let imgIndex = index"
                class="col-md-4 mb-3"
              >
                <div class="position-relative border rounded p-2">
                  <img
                    [src]="image.preview || image.url"
                    [alt]="image.name"
                    class="img-fluid rounded"
                    style="max-height: 150px; width: 100%; object-fit: contain;"
                  />
                  <button
                    type="button"
                    class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                    (click)="removeInstructionImage(imgIndex)"
                    style="z-index: 10;"
                  >
                    <i class="bx bx-x"></i>
                  </button>
                  <small class="d-block mt-1 text-muted text-truncate" [title]="image.name">
                    {{ image.name }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Table Section for Instructions -->
        <div class="mb-3">
          <label class="form-label">Table (Optional):</label>
          <div class="table-columns-editor">
            <div
              *ngFor="let column of newField.instructionColumns; let colIndex = index"
              class="column-item mb-2 p-2 border rounded"
            >
              <div class="row align-items-end">
                <div class="col-md-5">
                  <label class="form-label">Column Title</label>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="column.title"
                    placeholder="Column title"
                  />
                </div>

                <div class="col-md-4">
                  <label class="form-label">Column Type</label>
                  <select class="form-control" [(ngModel)]="column.type">
                    <option value="text">Text</option>
                    <option value="date">Date</option>
                    <option value="number">Number</option>
                    <option value="textarea">Textarea</option>
                    <option value="dropdown">Dropdown</option>
                    <option value="checkbox">Checkbox</option>
                  </select>
                </div>

                <div class="col-md-3">
                  <button
                    type="button"
                    class="btn custom-button2 w-100"
                    (click)="removeInstructionTableColumn(colIndex)"
                  >
                    <i class="bx bx-trash"></i> Remove
                  </button>
                </div>
              </div>
              <!-- Dropdown options editor for instruction table columns -->
              <div class="row mt-2" *ngIf="column.type === 'dropdown'">
                <div class="col-12">
                  <label class="form-label">Dropdown Options</label>
                  <div class="input-group mb-2">
                    <input
                      type="text"
                      class="form-control"
                      [(ngModel)]="column.newOptionText"
                      placeholder="Add option"
                      (keyup.enter)="addInstructionDropdownOption(colIndex)"
                    />
                    <button
                      class="btn custom-button"
                      type="button"
                      (click)="addInstructionDropdownOption(colIndex)"
                    >
                      Add
                    </button>
                  </div>
                  <div
                    *ngIf="column.values?.length"
                    class="d-flex flex-wrap gap-2"
                  >
                    <span
                      class="badge bg-secondary d-flex align-items-center"
                      *ngFor="let opt of column.values; let optIndex = index"
                    >
                      <span class="me-2">{{ opt.label }}</span>
                      <button
                        type="button"
                        class="cross-btn"
                        (click)="removeInstructionDropdownOption(colIndex, optIndex)"
                      >
                        x
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="button"
              class="btn custom-button"
              (click)="addInstructionTableColumn()"
            >
              <i class="bx bx-plus"></i> Add Column
            </button>
          </div>
          <!-- Add Rows Button -->
          <div *ngIf="newField.instructionColumns && newField.instructionColumns.length > 0" class="mt-3">
            <button
              type="button"
              class="btn custom-button"
              (click)="openAddRowsModal()"
            >
              <i class="bx bx-table"></i> Manage Table Rows
            </button>
            <small class="d-block text-muted mt-1" *ngIf="newField.instructionTableData && newField.instructionTableData.length > 0">
              {{ newField.instructionTableData.length }} row(s) added
            </small>
          </div>
        </div>
      </div>
      <!-- Table columns editor: visible for table type and fixed-rows-table -->
      <div class="mb-3" *ngIf="newField.type === 'table' || newField.type === 'fixed-rows-table'">
        <label class="form-label">Table Columns</label>
        <div class="table-columns-editor">
          <ng-container *ngFor="let column of newField.columns; let colIndex = index">
          <div
            *ngIf="!(newField.type === 'fixed-rows-table' && (column.isSrNo || column.name === '_sr_no'))"
            class="column-item mb-2 p-2 border rounded"
          >
            <div class="row">
              <div class="col-md-4">
                <label class="form-label">Column Title</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="column.title"
                  placeholder="Column title"
                  [disabled]="newField.type === 'fixed-rows-table' && (column.isSrNo || column.name === '_sr_no')"
                />
              </div>

              <div class="col-md-3">
                <label class="form-label">Column Type</label>
                <select class="form-control" [(ngModel)]="column.type" [disabled]="newField.type === 'fixed-rows-table' && (column.isSrNo || column.name === '_sr_no')">
                  <option value="text">Text</option>
                  <option value="statement">Statement</option>
                  <option value="date">Date</option>
                  <option value="number">Number</option>
                  <option value="textarea">Textarea</option>
                  <option value="dropdown">Dropdown</option>
                  <option value="checkbox">Checkbox</option>
                </select>
              </div>

              <div class="col-md-2">
                <label class="form-label">Required</label>
                <select class="form-control" [(ngModel)]="column.required" [disabled]="newField.type === 'fixed-rows-table' && (column.isSrNo || column.name === '_sr_no')">
                  <option [value]="false">No</option>
                  <option [value]="true">Yes</option>
                </select>
              </div>

              <div class="col-md-2">
                <!-- <label class="form-label">Actions</label> -->
                <button
                  type="button"
                  class="btn custom-button2"
                  style="margin-left: 10px"
                  (click)="removeTableColumn(colIndex)"
                  [disabled]="newField.type === 'fixed-rows-table' && ((column.isSrNo || column.name === '_sr_no') || (column.isSecondColumn || colIndex === 1))"
                  [title]="newField.type === 'fixed-rows-table' && ((column.isSrNo || column.name === '_sr_no') || (column.isSecondColumn || colIndex === 1)) ? (column.isSrNo || column.name === '_sr_no') ? 'Sr. No column cannot be removed' : 'Second column cannot be removed' : 'Remove column'"
                >
                  <i class="bx bx-trash"></i>
                </button>
              </div>
            </div>
            <!-- Dropdown options editor -->
            <div class="row mt-2" *ngIf="column.type === 'dropdown'">
              <div class="col-12">
                <label class="form-label">Dropdown Options</label>
                <div class="input-group mb-2">
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="column.newOptionText"
                    placeholder="Add option"
                    (keyup.enter)="addDropdownOption(colIndex)"
                  />
                  <button
                    class="btn custom-button"
                    type="button"
                    (click)="addDropdownOption(colIndex)"
                  >
                    Add
                  </button>
                </div>
                <div
                  *ngIf="column.values?.length"
                  class="d-flex flex-wrap gap-2"
                >
                  <span
                    class="badge bg-secondary d-flex align-items-center"
                    *ngFor="let opt of column.values; let optIndex = index"
                  >
                    <span class="me-2">{{ opt.label }}</span>
                    <button
                      type="button"
                      class="cross-btn"
                      (click)="removeDropdownOption(colIndex, optIndex)"
                    >
                      x
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
          </ng-container>
          <button
            type="button"
            class="btn custom-button"
            (click)="addTableColumn()"
          >
            <i class="bx bx-plus"></i> Add Column
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn custom-button me-2"
          (click)="closeCreateFieldModal()"
        >
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="isEditMode ? updateField() : addNewField()"
          [disabled]="!newField.title || !newField.type"
        >
          {{ isEditMode ? "Update" : "Create" }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Rows Modal -->
<div
  class="modal"
  *ngIf="showAddRowsModal"
  (click)="closeAddRowsModal()"
>
  <div
    class="modal-dialog"
    (click)="$event.stopPropagation()"
    style="max-width: 95%; width: 95%;"
  >
    <div class="modal-content edit-field-modal p-4">
      <h5 class="modal-title">
        Manage Table Rows
      </h5>
      
      <!-- Table Rows Editor -->
      <div class="table-rows-editor">
        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th *ngFor="let column of newField.instructionColumns">
                  {{ column.title || 'Column ' + ($index + 1) }}
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of newField.instructionTableData; let rowIndex = index">
                <td class="text-center fw-bold">{{ rowIndex + 1 }}</td>
                <td *ngFor="let column of newField.instructionColumns">
                  <!-- Text input -->
                  <input
                    *ngIf="column.type === 'text'"
                    type="text"
                    class="form-control form-control-sm"
                    [(ngModel)]="row[column.title]"
                    [placeholder]="'Enter ' + column.title"
                  />
                  <!-- Number input -->
                  <input
                    *ngIf="column.type === 'number'"
                    type="number"
                    class="form-control form-control-sm"
                    [(ngModel)]="row[column.title]"
                    [placeholder]="'Enter ' + column.title"
                  />
                  <!-- Date input -->
                  <input
                    *ngIf="column.type === 'date'"
                    type="date"
                    class="form-control form-control-sm"
                    [(ngModel)]="row[column.title]"
                  />
                  <!-- Textarea -->
                  <textarea
                    *ngIf="column.type === 'textarea'"
                    class="form-control form-control-sm"
                    rows="2"
                    [(ngModel)]="row[column.title]"
                    [placeholder]="'Enter ' + column.title"
                  ></textarea>
                  <!-- Dropdown -->
                  <select
                    *ngIf="column.type === 'dropdown'"
                    class="form-control form-control-sm"
                    [(ngModel)]="row[column.title]"
                  >
                    <option value="">Select</option>
                    <option *ngFor="let opt of column.values" [value]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                  <!-- Checkbox -->
                  <input
                    *ngIf="column.type === 'checkbox'"
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="row[column.title]"
                  />
                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    (click)="removeInstructionTableRow(rowIndex)"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                </td>
              </tr>
              <tr *ngIf="!newField.instructionTableData || newField.instructionTableData.length === 0">
                <td [attr.colspan]="newField.instructionColumns.length + 2" class="text-center text-muted">
                  No rows added yet. Click "Add Row" to add data.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3">
          <button
            type="button"
            class="btn custom-button"
            (click)="addInstructionTableRow()"
          >
            <i class="bx bx-plus"></i> Add Row
          </button>
          <button
            type="button"
            class="btn custom-button"
            (click)="closeAddRowsModal()"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Instruction Table Row Input Modal (Full Page) -->
<div
  class="modal"
  *ngIf="isInstructionTableRowModalOpen"
  (click)="closeInstructionTableRowModal()"
>
  <div
    class="modal-dialog"
    (click)="$event.stopPropagation()"
    style="max-width: 95%; width: 95%;"
  >
    <div class="modal-content edit-field-modal p-4">
      <h5 class="modal-title">
        Add New Row
      </h5>
      <p class="text-muted mb-3">Please enter values for all columns:</p>
      <div class="instruction-row-inputs">
        <div
          *ngFor="let column of newField.instructionColumns; let colIndex = index"
          class="mb-3"
        >
          <label class="form-label">
            {{ column.title || 'Column ' + ($index + 1) }}
            <span *ngIf="column.required" class="text-danger">*</span>
          </label>
          <!-- Text input -->
          <input
            *ngIf="column.type === 'text'"
            type="text"
            class="form-control"
            [(ngModel)]="instructionTableRowValues[column.title]"
            [placeholder]="'Enter ' + (column.title || 'value')"
            [required]="column.required"
          />
          <!-- Number input -->
          <input
            *ngIf="column.type === 'number'"
            type="number"
            class="form-control"
            [(ngModel)]="instructionTableRowValues[column.title]"
            [placeholder]="'Enter ' + (column.title || 'value')"
            [required]="column.required"
          />
          <!-- Date input -->
          <input
            *ngIf="column.type === 'date'"
            type="date"
            class="form-control"
            [(ngModel)]="instructionTableRowValues[column.title]"
            [required]="column.required"
          />
          <!-- Textarea -->
          <textarea
            *ngIf="column.type === 'textarea'"
            class="form-control"
            rows="3"
            [(ngModel)]="instructionTableRowValues[column.title]"
            [placeholder]="'Enter ' + (column.title || 'value')"
            [required]="column.required"
          ></textarea>
          <!-- Dropdown -->
          <select
            *ngIf="column.type === 'dropdown'"
            class="form-control"
            [(ngModel)]="instructionTableRowValues[column.title]"
            [required]="column.required"
          >
            <option value="">Select</option>
            <option *ngFor="let opt of column.values" [value]="opt.value">
              {{ opt.label }}
            </option>
          </select>
          <!-- Checkbox -->
          <div *ngIf="column.type === 'checkbox'" class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              [(ngModel)]="instructionTableRowValues[column.title]"
              [id]="'instruction-checkbox-' + column.title"
            />
            <label
              class="form-check-label"
              [for]="'instruction-checkbox-' + column.title"
            >
              {{ column.title || 'Check this option' }}
            </label>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button
          type="button"
          class="btn custom-button"
          (click)="closeInstructionTableRowModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn custom-button"
          (click)="submitInstructionTableRowModal()"
        >
          Add Row
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Duplicate Folder Modal -->
<div class="modal" *ngIf="showDuplicateFolderModal" (click)="closeDuplicateFolderModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-4">
      <h5 class="modal-title">Duplicate Folder</h5>
      <div class="mb-3">
        <p class="text-muted">
          Folder "<strong>{{ folderToDuplicate?.name }}</strong
          >" will be duplicated with all its forms and fields.
        </p>
      </div>
      <div class="mb-3">
        <label class="form-label">New Folder Name:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="duplicateFolderName"
          placeholder="Enter new folder name"
          (keyup.enter)="confirmDuplicateFolder()"
        />
        <div *ngIf="duplicateFolderNameError" class="text-danger mt-1">
          {{ duplicateFolderNameError }}
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn custom-button me-2"
          (click)="closeDuplicateFolderModal()"
        >
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="confirmDuplicateFolder()"
          [disabled]="!duplicateFolderName.trim() || duplicatingFolder"
        >
          <span *ngIf="!duplicatingFolder">Duplicate</span>
          <span *ngIf="duplicatingFolder">
            <i class="bx bx-loader-alt bx-spin me-1"></i>Duplicating...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Move Form Modal -->
<div class="modal" *ngIf="showMoveFormModal" (click)="closeMoveFormModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-4">
      <h5 class="modal-title">Move Form</h5>
      <div class="mb-3">
        <p class="text-muted">
          Move "<strong>{{ formToMove?.name }}</strong>" to:
        </p>
      </div>
      <div class="mb-3">
        <label class="form-label">Target folder</label>
        <div class="list-group">
          <button
            *ngFor="let targetFolder of getMoveFormTargetFolders()"
            type="button"
            class="list-group-item list-group-item-action"
            [class.active]="moveFormTargetFolderId === targetFolder.id"
            (click)="moveFormTargetFolderId = targetFolder.id"
          >
            {{ targetFolder.name }}
          </button>
          <p *ngIf="getMoveFormTargetFolders().length === 0" class="text-muted mb-0">
            No other folders available.
          </p>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn custom-button me-2"
          (click)="closeMoveFormModal()"
        >
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="confirmMoveForm()"
          [disabled]="!moveFormTargetFolderId || movingForm"
        >
          <span *ngIf="!movingForm">Move</span>
          <span *ngIf="movingForm">
            <i class="bx bx-loader-alt bx-spin me-1"></i>Moving...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Duplicate Form Modal -->
<div class="modal" *ngIf="showDuplicateFormModal" (click)="closeDuplicateFormModal()">
  <div class="modal-dialog" (click)="$event.stopPropagation()">
    <div class="modal-content p-4">
      <h5 class="modal-title">Duplicate Form</h5>
      <div class="mb-3">
        <p class="text-muted">
          Form "<strong>{{ formToDuplicate?.name }}</strong
          >" will be duplicated with all its fields.
        </p>
      </div>
      <div class="mb-3">
        <label class="form-label">New Form Name:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="duplicateFormName"
          placeholder="Enter new form name"
          (keyup.enter)="confirmDuplicateForm()"
        />
        <div *ngIf="duplicateFormNameError" class="text-danger mt-1">
          {{ duplicateFormNameError }}
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label">Select Folder(s):</label>
        <div class="dropdown w-100">
          <button
            type="button"
            class="btn btn-outline-secondary dropdown-toggle w-100 text-start"
            (click)="toggleDuplicateFormFolderDropdown()"
          >
            {{ getDuplicateFormFolderDropdownLabel() }}
          </button>
          <div
            class="dropdown-menu w-100 show"
            *ngIf="showDuplicateFormFolderDropdown"
            style="max-height: 250px; overflow-y: auto;"
          >
            <div class="px-3 py-2 text-muted" *ngIf="!availableFolders || availableFolders.length === 0">
              No folders available
            </div>
            <div
              class="form-check px-3 py-1"
              *ngFor="let folder of availableFolders"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'duplicateFolder_' + folder.id"
                [checked]="isDuplicateFormFolderSelected(folder.id)"
                (change)="onDuplicateFormFolderToggle(folder.id, $event.target.checked)"
              />
              <label
                class="form-check-label"
                [for]="'duplicateFolder_' + folder.id"
              >
                {{ folder.name }}
              </label>
            </div>
          </div>
        </div>
        <small class="text-muted">
          Choose one or more folders where the duplicated form should be saved.
        </small>
        <div *ngIf="duplicateFormFolderError" class="text-danger mt-1">
          {{ duplicateFormFolderError }}
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn custom-button me-2"
          (click)="closeDuplicateFormModal()"
        >
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="confirmDuplicateForm()"
          [disabled]="!duplicateFormName.trim() || duplicatingForm"
        >
          <span *ngIf="!duplicatingForm">Duplicate</span>
          <span *ngIf="duplicatingForm">
            <i class="bx bx-loader-alt bx-spin me-1"></i>Duplicating...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Statement Input Modal for Fixed Rows Table -->
<div
  class="modal"
  *ngIf="isStatementModalOpen"
  (click)="closeStatementModal()"
  style="display: block; background-color: rgba(0, 0, 0, 0.5);"
>
  <div
    class="modal-dialog"
    (click)="$event.stopPropagation()"
    style="max-width: 95%; width: 95%; margin: 2rem auto;"
  >
    <div class="modal-content edit-field-modal p-4">
      <h5 class="modal-title mb-3">
        {{ statementModalRowIndex === null ? 'Enter Statement Values' : 'Edit Statement Values' }}
      </h5>
      <p class="text-muted mb-3">Please enter values for all statement columns:</p>
      <div class="statement-inputs">
        <div
          *ngFor="let column of statementModalColumns"
          class="mb-3"
        >
          <label class="form-label">
            {{ column.title }}
            <span *ngIf="column.required" class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control"
            [ngModel]="statementModalValues[getStatementColumnKey(column)]"
            (ngModelChange)="statementModalValues[getStatementColumnKey(column)] = $event"
            [placeholder]="'Enter ' + (column.title || 'value')"
            [required]="column.required"
          />
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button
          type="button"
          class="btn custom-button"
          (click)="closeStatementModal()"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn custom-button"
          (click)="submitStatementModal()"
        >
          {{ statementModalRowIndex === null ? 'Add Row' : 'Update' }}
        </button>
      </div>
    </div>
  </div>
</div>